import { useStore } from 'vuex';
import { mutationTypes as MUTATION, actionTypes as ACTION, getterTypes as GETTERS } from '../store/types';

import { MODULE_NAME } from '../constants/moduleConstants';

export const useProductPickerStore = () => {
  const store = useStore();

  const query = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_QUERY}`]);

  const fetchedAll = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_FETCHED_ALL}`]);

  const fetchedAllQuery = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_FETCHED_ALL_QUERY}`]);

  const isLoading = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_IS_LOADING}`]);

  const isMessage = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_IS_MESSAGE}`]);

  const isRefresh = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_IS_REFRESH}`]);

  const productsList = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_PRODUCTS_LIST}`]);

  const queryList = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_QUERY_LIST}`]);

  const cachedQueryList = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_CACHED_QUERY_LIST}`]);

  const moduleIdInStore = computed(() => store.getters[`${MODULE_NAME}/${GETTERS.GET_PRODUCT_MODULE_ID}`]);

  const setLoading = (value: boolean) => {
    store.commit(`${MODULE_NAME}/${MUTATION.SET_IS_LOADING}`, value);
  };

  const setIsDisplayMessage = (value: boolean) => {
    store.commit(`${MODULE_NAME}/${MUTATION.SET_IS_MESSAGE}`, value);
  };

  const setRefresh = (value: boolean) => {
    store.commit(`${MODULE_NAME}/${MUTATION.SET_IS_REFRESH}`, value);
  };

  const setQuery = (value: string) => {
    store.commit(`${MODULE_NAME}/${MUTATION.SET_QUERY}`, value);
  };

  const setQueryList = (list: any[]) => {
    store.commit(`${MODULE_NAME}/${MUTATION.SET_QUERY_LIST}`, list);
  };

  const setOpenPopup = (value: boolean) => {
    store.commit(`${MODULE_NAME}/${MUTATION.SET_IS_OPEN_POPUP}`, value);
  };

  const setCurrentEditModule = (value: number) => {
    store.commit(`${MODULE_NAME}/${MUTATION.SET_PRODUCT_MODULE_ID}`, value);
  };

  const resetSearchData = () => {
    store.commit(`${MODULE_NAME}/${MUTATION.RESET_SEARCH_RESULT}`);
  };

  const resetProductData = () => {
    store.commit(`${MODULE_NAME}/${MUTATION.RESET_PRODUCT_DATA}`);
  };

  const fetchProducts = async (params?: { disableLoading?: boolean }) => {
    const payload = {
      query: query.value,
      page_id: store.state.app.pageInfo.page.id,
      changeQuery: false,
    };

    !params?.disableLoading && setLoading(true);

    await store
      .dispatch(`${MODULE_NAME}/${ACTION.FETCH_PRODUCTS}`, payload)
      .catch((err: any) => {
        // eslint-disable-next-line no-console
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
        isRefresh && setRefresh(false);
      });
  };

  return {
    fetchProducts,
    setRefresh,
    setQuery,
    setLoading,
    setQueryList,
    setOpenPopup,
    setIsDisplayMessage,
    setCurrentEditModule,
    resetSearchData,
    resetProductData,
    moduleIdInStore,
    productsList,
    queryList,
    isLoading,
    isRefresh,
    isMessage,
    query,
    cachedQueryList,
    fetchedAll,
    fetchedAllQuery,
  };
};
